export function getServicePackageStatus({ executedCount, notExecutedCount }) {
  if (executedCount > 0 && notExecutedCount > 0) {
    return "Partially executed"
  } else if (notExecutedCount === 0) {
    return "Executed"
  } else if (executedCount === 0) {
    return "Not executed"
  }
}
